const languagePrefix =
  (typeof window !== "undefined" &&
    window.localStorage.getItem("fibank-language")) ||
  "sq";

const buildURLHelper = (tree) => {
  if (tree === undefined) {
    return "";
  } else if (tree.parentCategory === null) {
    return tree.slug;
  } else {
    if (tree.parentCategory) {
      return `${buildURLHelper(tree.parentCategory)}/${tree.slug}`;
    }
    return `${tree.slug}`;
  }
};

export const buildURL = (tree, defaultLanguage = "sq") => {
  let categoriesPath = "";
  if (tree && tree.parentCategory) {
    categoriesPath = `/${buildURLHelper(tree.parentCategory)}`;
  }

  return `${languagePrefix || defaultLanguage}${categoriesPath}`.replace(
    /\/$/,
    ""
  );
};

export const buildURLForArticle = (article, forceLanguage) => {
  let categoriesPath = "";
  if (!article) {
    return categoriesPath;
  }

  if (article && article.category) {
    categoriesPath = `/${buildURLHelper(article.category)}`;
  }

  let langParam = "";
  if (forceLanguage) {
    langParam = `/${forceLanguage}`;
  }

  return `${langParam}${categoriesPath}/${article.slug}`;
};

export const buildURLForCategory = (category, forceLanguage) => {
  let categoriesPath = "";
  if (!category) {
    return categoriesPath;
  }
  if (category.parentCategory) {
    categoriesPath = `/${buildURLHelper(category.parentCategory)}`;
  }

  let langParam = "";
  if (forceLanguage) {
    langParam = `/${forceLanguage}`;
  }

  return `${langParam}${categoriesPath || ""}/${category.slug || ""}`;
};

export const buildURLForMenuItem = (item, forceLanguage) => {
  if (!item) {
    return "";
  }

  if (!item.type && item.slug) {
    return `/${item.slug}`;
  }

  if (item.type === "URI") {
    return item.uri;
  } else if (item.type === "Article") {
    return buildURLForArticle(item.article, forceLanguage);
  } else if (item.type === "Category") {
    return buildURLForCategory(item.category, forceLanguage);
  } else {
    return "";
  }
};
